import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { emitStyleUpdate } from "../Socket/Socket";
import { slideAction, saveMirrorToCloudinary } from "../store/slideSlice";
import { getSnapshot } from "../utils/utils";
import { slideAPI } from "../store/api";
import { isStyleChanged, updateElementStyle } from "../utils/helper";
import LayoutEnum from "../utils/layoutEnum";

const getResizeSurface = (element) => element?.parentElement?.parentElement;

/** Resolve the draggable slide element from an event target (preserves pre-WordArt behavior). */
const resolveDragElement = (target) => {
  if (!target || target.classList?.contains('resizer')) return null;

  const wordArtEl = target.closest?.('.wordart');
  if (wordArtEl) return wordArtEl;

  if (
    target.classList.contains('ql-container') ||
    target.classList.contains('ql-editor') ||
    target.id.includes('shape') ||
    target.parentElement?.classList.contains('image') ||
    target.parentElement?.classList.contains('shape')
  ) {
    return !target.classList.contains('ql-container')
      ? document.getElementById(target.parentElement.id)
      : document.getElementById(target.id);
  }

  return null;
};

const isDraggableTarget = (target) => resolveDragElement(target) !== null;

const SLIDE_ROOT_IDS = ['slide01', 'master-slide'];
export const SLIDE_SELECTION_CLEAR = 'mileslide-clear-selection';

/** Remove selection chrome from all slide elements except the active one. */
export const clearAllSlideSelections = (exceptElement = null) => {
  const exceptId = exceptElement?.id;

  SLIDE_ROOT_IDS.forEach((slideId) => {
    const slide = document.getElementById(slideId);
    if (!slide) return;
    slide.querySelectorAll('.selected').forEach((el) => {
      if (exceptId && el.id === exceptId) return;
      el.classList.remove('selected');
      el.querySelectorAll('.resizer').forEach((handle) => handle.remove());
    });
  });

  window.dispatchEvent(
    new CustomEvent(SLIDE_SELECTION_CLEAR, { detail: { exceptId: exceptId || null } })
  );
};

const useResizer = () => {
  const { id } = useParams();
  const existingSlides = useSelector((state) => state.slide.slides);
  let currentSlideId = useSelector(state => state.slide.currentSlideId);
  const isMasterSlide = useSelector((state) => state.slide.isMasterSlide);
  const masterSlideId = useSelector(state => state.slide.masterSlideId);
  const presentMode = useSelector((state) => state.slide.presentMode);
  const mirrorSlides = useSelector((state) => state.slide.mirrorSlides);
  const dispatch = useDispatch();
  const pageWidth = window.screen.width > 2200 ? 1800 : window.screen.width > 1540 ? 1200 : window.screen.width > 1200 ? 960 : window.screen.width > 992 ? 848 : window.screen.width > 768 ? 700 : window.screen.width > 490 ? 490 : 300;
  const pageHeight = window.screen.width > 2200 ? 1020 : window.screen.width > 1540 ? 700 : window.screen.width > 1200 ? 540 : window.screen.width > 992 ? 500 : window.screen.width > 768 ? 400 : window.screen.width > 490 ? 290 : 180;

  const addResizer = (element) => {
    // dispatch(slideAction.setCurrentElement(element.id))
    // console.log("resizer re evaluate");
    // let element= quill.container;  
    if (element.id.includes('image') || element.id.includes('shape') ||
      element.id.includes('wordart') ||
      element.id.includes('text') || element.id.includes('title') || element.id.includes('layout')) {
      clearAllSlideSelections(element);
      element.querySelectorAll('.resizer').forEach((handle) => handle.remove());
      element.classList.add('selected');
      const resizeBoxNW = document.createElement("div");
      resizeBoxNW.classList.add("resizer");
      resizeBoxNW.classList.add("top-left");
      element.appendChild(resizeBoxNW);

      const resizeBoxNE = document.createElement("div");
      resizeBoxNE.classList.add("resizer");
      resizeBoxNE.classList.add("top-right");
      element.appendChild(resizeBoxNE);

      const resizeBoxSW = document.createElement("div");
      resizeBoxSW.classList.add("resizer");
      resizeBoxSW.classList.add("bottom-left");
      element.appendChild(resizeBoxSW);

      const resizeBoxSE = document.createElement("div");
      resizeBoxSE.classList.add("resizer");
      resizeBoxSE.classList.add("bottom-right");
      element.appendChild(resizeBoxSE);

      const resizeBoxTop = document.createElement("div");
      resizeBoxTop.classList.add("resizer");
      resizeBoxTop.classList.add("top");
      // resizeBoxTop.style.left = Number(quillContainer.style.width.slice(0,quillContainer.style.width.length - 1))/2+"%";
      element.appendChild(resizeBoxTop);

      const resizeBoxRight = document.createElement("div");
      resizeBoxRight.classList.add("resizer");
      resizeBoxRight.classList.add("right");
      // resizeBoxRight.style.top = Number(quillContainer.style.height.slice(0,quillContainer.style.height.length - 1))/2 +"%";
      element.appendChild(resizeBoxRight);

      const resizeBoxBottom = document.createElement("div");
      resizeBoxBottom.classList.add("resizer");
      resizeBoxBottom.classList.add("bottom");
      // resizeBoxBottom.style.left = Number(quillContainer.style.width.slice(0,quillContainer.style.width.length - 1)) /2 +"%";
      element.appendChild(resizeBoxBottom);

      const resizeBoxLeft = document.createElement("div");
      resizeBoxLeft.classList.add("resizer");
      resizeBoxLeft.classList.add("left");
      // resizeBoxLeft.style.top = Number(quillContainer.style.height.slice(0,quillContainer.style.height.length - 1)) /2 + "%";
      element.appendChild(resizeBoxLeft);


      let resizers = element.querySelectorAll(".resizer");
      // let currentResizer;

      /// new code

      const minimum_size = 20;
      let original_width = 0;
      let original_height = 0;
      let original_x = 0;
      let original_y = 0;
      let original_mouse_x = 0;
      let original_mouse_y = 0;
      for (let i = 0; i < resizers.length; i++) {
        const currentResizer = resizers[i];
        currentResizer.addEventListener("mousedown", function (e) {
          e.stopPropagation();
          e.preventDefault();
          original_width = parseFloat(
            getComputedStyle(element, null)
              .getPropertyValue("width")
              .replace("%", "")
          );
          original_height = parseFloat(
            getComputedStyle(element, null)
              .getPropertyValue("height")
              .replace("%", "")
          );
          original_x = Number(
            element.style.left.slice(0, element.style.left.length - 1) / 100 * pageWidth
          );
          original_y = Number(
            element.style.top.slice(0, element.style.top.length - 1) / 100 * pageHeight
          );
          original_mouse_x = e.pageX;
          original_mouse_y = e.pageY;
          const resizeSurface = getResizeSurface(element);
          resizeSurface?.addEventListener('mousemove', resize);
          resizeSurface?.addEventListener('mouseup', stopResize);
        });

        function resize(e) {
          if (currentResizer.classList.contains("top")) {
            const height = original_height - (e.pageY - original_mouse_y);
            if (height > minimum_size) {
              element.style.height = height / pageHeight * 100 + "%";
              element.style.top =
                (original_y + (e.pageY - original_mouse_y)) / pageHeight * 100 + "%";
              // resizeBoxRight.style.top = ((height/ 600)* 100) / 2 + "%";
              // resizeBoxLeft.style.top = ((height/ 600)* 100) / 2 + "%";
            }
          } else if (currentResizer.classList.contains("bottom")) {
            const height = original_height - (original_mouse_y - e.pageY);
            if (height > minimum_size) {
              element.style.height = height / pageHeight * 100 + "%";
              // resizeBoxRight.style.top = ((height/ 600)* 100) / 2 + "%";
              // resizeBoxLeft.style.top = ((height/ 600)* 100) / 2 + "%";
            }
          } else if (currentResizer.classList.contains("left")) {
            const width = original_width - (e.pageX - original_mouse_x);
            if (width > minimum_size) {
              element.style.width = width / pageWidth * 100 + "%";
              element.style.left =
                (original_x + (e.pageX - original_mouse_x)) / pageWidth * 100 + "%";
            }
          } else if (currentResizer.classList.contains("right")) {
            const width = original_width - (original_mouse_x - e.pageX);
            if (width > minimum_size) {
              element.style.width = width / pageWidth * 100 + "%";
              // resizeBoxTop.style.left = ((width/1200)*100) / 2 + "%";
              // resizeBoxBottom.style.left = ((width/1200)*100) / 2 + "%";
            }
          } else if (currentResizer.classList.contains("bottom-right")) {
            const width = original_width + (e.pageX - original_mouse_x);
            const height = original_height + (e.pageY - original_mouse_y);
            if (width > minimum_size) {
              element.style.width = width / pageWidth * 100 + "%";
              // resizeBoxTop.style.left = ((width/1200)*100) / 2 + "%";
              // resizeBoxBottom.style.left = ((width/1200)*100) / 2 + "%";
            }
            if (height > minimum_size) {
              element.style.height = height / pageHeight * 100 + "%";
              // resizeBoxRight.style.top = ((height/ 600)* 100) / 2 + "%";
              // resizeBoxLeft.style.top = ((height/ 600)* 100) / 2 + "%";
            }
          } else if (currentResizer.classList.contains("bottom-left")) {
            const height = original_height + (e.pageY - original_mouse_y);
            const width = original_width - (e.pageX - original_mouse_x);
            if (height > minimum_size) {
              element.style.height = height / pageHeight * 100 + "%";
              // resizeBoxRight.style.top = ((height/ pageHeight)* 100) / 2 + "%";
              // resizeBoxLeft.style.top = ((height/ pageHeight)* 100) / 2 + "%";
            }
            if (width > minimum_size) {
              element.style.width = width / pageWidth * 100 + "%";
              element.style.left =
                (original_x + (e.pageX - original_mouse_x)) / pageWidth * 100 + "%";
              // resizeBoxTop.style.left = ((width/1200)*100) / 2 + "%";
              // resizeBoxBottom.style.left = ((width/1200)*100) / 2 + "%";
            }
          } else if (currentResizer.classList.contains("top-right")) {
            const width = original_width + (e.pageX - original_mouse_x);
            const height = original_height - (e.pageY - original_mouse_y);
            if (width > minimum_size) {
              element.style.width = width / pageWidth * 100 + "%";
              // resizeBoxTop.style.left = ((width/1200)*100) / 2 + "%";
              // resizeBoxBottom.style.left = ((width/1200)*100) / 2 + "%";
            }
            if (height > minimum_size) {
              element.style.height = height / pageHeight * 100 + "%";
              element.style.top = (original_y + (e.pageY - original_mouse_y)) / pageHeight * 100 + "%";
              // resizeBoxRight.style.top = ((height/ 600)* 100) / 2 + "%";
              // resizeBoxLeft.style.top = ((height/ 600)* 100) / 2 + "%";
            }
          } else {
            const width = original_width - (e.pageX - original_mouse_x);
            const height = original_height - (e.pageY - original_mouse_y);
            if (width > minimum_size) {
              element.style.width = width / pageWidth * 100 + "%";
              element.style.left =
                (original_x + (e.pageX - original_mouse_x)) / pageWidth * 100 + "%";
              // resizeBoxTop.style.left = ((width/1200)*100) / 2 + "%";
              // resizeBoxBottom.style.left = ((width/1200)*100) / 2 + "%";
            }
            if (height > minimum_size) {
              element.style.height = height / pageHeight * 100 + "%";
              element.style.top =
                (original_y + (e.pageY - original_mouse_y)) / pageHeight * 100 + "%";
              // resizeBoxRight.style.top = ((height/ 600)* 100) / 2 + "%";
              // resizeBoxLeft.style.top = ((height/ 600)* 100) / 2 + "%";
            }
          }
        }

        function stopResize() {
          if (isMasterSlide) {
            currentSlideId = masterSlideId;
          }
          const resizeSurface = getResizeSurface(element);
          resizeSurface?.removeEventListener('mousemove', resize);
          let cssStyle = element.getAttribute('style');
          let updatedStyle = {};
          let regex = /([\w-]*)\s*:\s*([^;]*)/g;
          let match;
          while (match = regex.exec(cssStyle)) { updatedStyle[match[1]] = match[2].trim(); }
          let eleId = element.getAttribute('id');
          const type = eleId.includes('wordart') ? 'wordart' : (eleId.includes('text') || eleId.includes('layout') ? 'text' : (eleId.includes('image') ? 'image' : 'shape'));
          const existingData = getExistingData(type, currentSlideId, eleId, existingSlides);
          let isChanged = existingData && isStyleChanged(existingData.styles, updatedStyle);
          isChanged && emitStyleUpdate({ roomId: id, elementData: { slideId: currentSlideId, textBoxId: element.getAttribute('id'), updatedStyle: updatedStyle } })
          if (!isMasterSlide && isChanged) {
            dispatch(slideAction.updateStyle({ slideId: currentSlideId, textBoxId: element.getAttribute('id'), updatedStyle: updatedStyle }));
            removeResizer(element);
            getSnapshot().then((dataUrl) => {
              dispatch(saveMirrorToCloudinary({ dataId: currentSlideId, mirrorSlideDataUrl: dataUrl, presentationId: id }));
              addResizer(element);
            });
            let payload = {
              textBoxId: eleId,
              updatedStyle: updatedStyle,
              currentSlideId: currentSlideId
            }
            const updatedSlides = updateElementStyle(existingSlides, payload, type);
            const data = {
              slides: updatedSlides,
              mirrorSlides: mirrorSlides
            }
            slideAPI.updateElementStyleInDatabase(id, currentSlideId, element.getAttribute('id'), updatedStyle, type, dispatch, data);
          }
          else if (isMasterSlide && isChanged) {
            dispatch(slideAction.updateStyle({ slideId: masterSlideId, textBoxId: eleId, updatedStyle: updatedStyle }));
            const isMainMasterSlide = !Object.values(LayoutEnum).some(layout => currentSlideId.toLowerCase().includes(layout.toLowerCase()));
            if (isMainMasterSlide) {
              Object.keys(existingSlides).forEach((slideId) => {
                const isMasterLayout = Object.values(LayoutEnum).some((enumValue) =>
                  slideId.includes(enumValue)
                );
                if (isMasterLayout) {
                  dispatch(slideAction.updateStyle({ slideId: slideId, textBoxId: eleId, updatedStyle: updatedStyle }));
                }
              });
            }
            const layoutType = isMainMasterSlide ? null : existingSlides[masterSlideId].layoutType;
            slideAPI.updateMultipleElementStyleInDatabase(id, element.getAttribute('id'), updatedStyle, type,layoutType);
            // handleMasterSlideUpdate(updatedStyle, element, type);
          }
          // element.classList.add('selected');
          resizeSurface?.removeEventListener('mouseup', stopResize);
        }
      }
    }
  }

  const removeResizer = (element) => {

    if (element.id) {
      element.classList.remove('selected');
      element.querySelectorAll(".resizer").forEach((e) => e.remove());
    } else {
      element.parentElement.classList.remove('selected');
      element.parentElement.querySelectorAll(".resizer").forEach((e) => e.remove());
    }
  }

  const dragEvent = (e) => {
    e.stopPropagation();
    if (presentMode || !isDraggableTarget(e.target)) return;

    const ele = resolveDragElement(e.target);
    if (!ele) return;

    ele.style.position = 'absolute';

    const dragSurface = getResizeSurface(ele);
    if (!dragSurface) return;

    let newX;
    let newY;
    let prevX;
    let prevY;
    let original_prevX;
    let original_prevY;

    dragSurface.addEventListener('mousemove', mouseMoveDrag, false);
    dragSurface.addEventListener('mouseup', mouseUp, false);

    original_prevX =
      (Number(ele.style.left.slice(0, ele.style.left.length - 1)) / 100) * pageWidth;
    original_prevY =
      Number((ele.style.top.slice(0, ele.style.top.length - 1) / 100) * pageHeight);

    prevX = e.pageX;
    prevY = e.pageY;

    function mouseMoveDrag(moveEvent) {
      if (ele.id === 'slide01' || ele.id === 'master-slide') {
        moveEvent.preventDefault();
        return;
      }
      if (moveEvent.target.tagName === 'IMG' || moveEvent.target.tagName === 'svg') {
        moveEvent.preventDefault();
      }
      moveEvent.stopPropagation();
      newX = moveEvent.pageX - prevX + original_prevX;
      newY = moveEvent.pageY - prevY + original_prevY;
      ele.style.left = `${(newX / pageWidth) * 100}%`;
      ele.style.top = `${(newY / pageHeight) * 100}%`;
    }

    function mouseUp() {
      dragSurface.removeEventListener('mousemove', mouseMoveDrag);

      const cssStyle = ele.getAttribute('style');
      const updatedStyle = {};
      const regex = /([\w-]*)\s*:\s*([^;]*)/g;
      let match;
      while ((match = regex.exec(cssStyle))) {
        updatedStyle[match[1]] = match[2].trim();
      }

      const eleId = ele.getAttribute('id');
      const type = eleId.includes('wordart')
        ? 'wordart'
        : eleId.includes('text') || eleId.includes('layout')
          ? 'text'
          : eleId.includes('image')
            ? 'image'
            : 'shape';
      const existingData = getExistingData(type, currentSlideId, eleId, existingSlides);
      const isChanged = existingData && isStyleChanged(existingData.styles, updatedStyle);
      const shouldRestoreSelection =
        ele.id !== 'slide01' && ele.id !== 'master-slide';
      removeResizer(ele);
      if (isChanged) {
        emitStyleUpdate({
          roomId: id,
          elementData: { slideId: currentSlideId, textBoxId: eleId, updatedStyle },
        });
        if (!isMasterSlide) {
          getSnapshot().then((dataUrl) => {
            dispatch(saveMirrorToCloudinary({
              dataId: currentSlideId,
              mirrorSlideDataUrl: dataUrl,
              presentationId: id,
            }));
            dispatch(
              slideAction.updateStyle({ slideId: currentSlideId, textBoxId: eleId, updatedStyle })
            );
            if (ele.id !== 'slide01' && ele.id !== 'master-slide') {
              addResizer(ele);
            }
          });
          const payload = {
            textBoxId: eleId,
            updatedStyle,
            currentSlideId,
          };
          const updatedSlides = updateElementStyle(existingSlides, payload, type);
          slideAPI.updateElementStyleInDatabase(id, currentSlideId, eleId, updatedStyle, type, dispatch, {
            slides: updatedSlides,
            mirrorSlides,
          });
        } else {
          if (ele.id !== 'slide01' && ele.id !== 'master-slide') {
            addResizer(ele);
          }
          dispatch(
            slideAction.updateStyle({ slideId: masterSlideId, textBoxId: eleId, updatedStyle })
          );
          const isMainMasterSlide = !Object.values(LayoutEnum).some((layout) =>
            currentSlideId.toLowerCase().includes(layout.toLowerCase())
          );
          if (isMainMasterSlide) {
            Object.keys(existingSlides).forEach((slideId) => {
              const isMasterLayout = Object.values(LayoutEnum).some((enumValue) =>
                slideId.includes(enumValue)
              );
              if (isMasterLayout) {
                dispatch(
                  slideAction.updateStyle({ slideId, textBoxId: eleId, updatedStyle })
                );
              }
            });
          }
          const layoutType = isMainMasterSlide ? null : existingSlides[masterSlideId].layoutType;
          slideAPI.updateMultipleElementStyleInDatabase(id, eleId, updatedStyle, type, layoutType);
        }
      } else if (shouldRestoreSelection) {
        addResizer(ele);
      }
      dragSurface.removeEventListener('mouseup', mouseUp);
    }
  }

  function delay(t) {
    return new Promise(resolve => setTimeout(resolve, t));
  }

  async function handleMasterSlideUpdate(updatedStyle, ele, type) {
    let eleId = ele.getAttribute('id');
    const slideKeys = Object.keys(existingSlides).filter(slideId => !slideId.includes('master'));
    for (let slideId of slideKeys) {
      dispatch(slideAction.updateStyle({
        slideId: slideId,
        textBoxId: eleId,
        updatedStyle: {
          ...updatedStyle,
          pointerEvents: 'none'
        },
      }));
      dispatch(slideAction.setCurrentSlide(slideId));
      await delay(500);
    }
    slideAPI.updateMultipleElementStyleInDatabase(id, ele.getAttribute('id'), updatedStyle, type);
    dispatch(slideAction.setCurrentSlide(masterSlideId));
  }

  function getExistingData(type, currentSlideId, eleId, existingSlides) {
    switch (type) {
      case 'text':
        return existingSlides[currentSlideId].textBox[eleId] || null;
      case 'image':
        return existingSlides[currentSlideId].image[eleId] || null;
      case 'shape':
        return existingSlides[currentSlideId].shapes[eleId] || null;
      case 'wordart':
        return existingSlides[currentSlideId]?.wordArtTextObjects?.[eleId] || null;
      default:
        return null;
    }
  }

  return [addResizer, removeResizer, dragEvent]
}

export default useResizer;